import './App.css';
import './index.scss';
import ModuleLoader from './components/module-loader/ModuleLoader';
import { StrictMode } from 'react';
import { TAppContextConfig } from './types';
import { AppContextProvider } from './components/app-context/app-context-provider';
import { AppStateContextProvider } from './components/app-state/app-state-provider';

export type TAppProps = {
    moduleName: string;
    appContext?: TAppContextConfig;
    appState?: Record<string, any>;
} & Record<string, any>;

export const App = ({
    moduleName,
    appContext,
    appState,
    ...params
}: TAppProps) => (
    <StrictMode>
            <AppStateContextProvider state={appState}>
                <AppContextProvider context={appContext}>
                    <ModuleLoader moduleName={moduleName} {...params} />
                </AppContextProvider>
            </AppStateContextProvider>
    </StrictMode>
);

export default App;
